import { lazy } from 'react'

const AdminRoutes = [
  {
    path: '/admin/user/changeUser/:email',
    component: lazy(() => import('../../views/admin-panel')),
    exact: true,
    meta: {
      publicRoute: true
    }
  },
  {
    path: '/admin/users',
    component: lazy(() => import('../../views/admin-panel/users')),
    exact: true,
    meta: {
      publicRoute: true
    }
  },
  {
    path: '/admin/users/:id',
    component: lazy(() => import('../../views/admin-panel/users/edit')),
    exact: true,
    meta: {
      publicRoute: true
    }
  },
  {
    path: '/admin/ranks',
    component: lazy(() => import('../../views/admin-panel/rank')),
    exact: true,
    meta: {
      publicRoute: true
    }
  },
  {
    path: '/admin/ranks/add',
    component: lazy(() => import('../../views/admin-panel/rank/addRank')),
    exact: true,
    meta: {
      publicRoute: true
    }
  },
  {
    path: '/admin/ranks/:id',
    component: lazy(() => import('../../views/admin-panel/rank/editRank')),
    exact: true,
    meta: {
      publicRoute: true
    }
  },

  {
    path: '/admin/reportFeed',
    component: lazy(() => import('../../views/admin-panel/report-feed')),
    exact: true,
    meta: {
      publicRoute: false,
      action: 'manage'
    }
  },
  {
    path: '/admin/banners',
    component: lazy(() => import('../../views/admin-panel/banners')),
    exact: true,
    meta: {
      publicRoute: false,
      action: 'manage'
    }
  },
  {
    path: '/admin/banners/add',
    component: lazy(() => import('../../views/admin-panel/banners/add.js')),
    exact: true,
    meta: {
      publicRoute: false,
      action: 'manage'
    }
  },
  {
    path: '/admin/tournaments',
    component: lazy(() => import('../../views/admin-panel/tournament')),
    exact: true,
    meta: {
      publicRoute: false,
      action: 'manage'
    }
  },
  {
    path: '/admin/tournaments/:id/',
    component: lazy(() => import('../../views/admin-panel/tournament')),
    exact: true,
    meta: {
      publicRoute: false,
      action: 'manage'
    }
  },
  {
    path: '/admin/tournaments/:id/rounds',
    component: lazy(() => import('../../views/admin-panel/tournament/round')),
    exact: true,
    meta: {
      publicRoute: false,
      action: 'manage'
    }
  },
  {
    path: '/admin/tournaments/:id/addRound',
    component: lazy(() => import('../../views/admin-panel/tournament/round/add')),
    exact: true,
    meta: {
      publicRoute: false,
      action: 'manage'
    }
  },
  {
    path: '/admin/tournaments/:tournamentId/rounds/:roundId/tasks',
    component: lazy(() => import('../../views/admin-panel/tournament/task')),
    exact: true,
    meta: {
      publicRoute: false,
      action: 'manage'
    }
  },
  {
    path: '/admin/tournaments/:tournamentId/rounds/:roundId/addTask',
    component: lazy(() => import('../../views/admin-panel/tournament/task/addTask')),
    exact: true,
    meta: {
      publicRoute: false,
      action: 'manage'
    }
  },
  {
    path: '/admin/approveCustomBetsSettlement',
    component: lazy(() => import('../../views/admin-panel/approve-custom-bets-settlement')),
    exact: true,
    meta: {
      publicRoute: false,
      action: 'manage'
    }
  }

]

export default AdminRoutes
